import { useState, useEffect } from "react";
import { differenceInSeconds, parseISO } from "date-fns";

export function useCountdown(targetDate: string | null) {
  const [remaining, setRemaining] = useState<number | null>(null);

  useEffect(() => {
    if (!targetDate) return;
    const update = () => {
      const diff = differenceInSeconds(parseISO(targetDate), new Date());
      setRemaining(diff);
    };
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  if (remaining === null) return null;
  if (remaining <= 0) return { locked: true as const, text: "Tips Locked" };

  const d = Math.floor(remaining / 86400);
  const h = Math.floor((remaining % 86400) / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = remaining % 60;
  return { locked: false as const, text: `Tips lock in: ${d}d ${h}h ${m}m ${s}s` };
}
